import 'globalthis-polyfill'
import React from 'react'
import ym from 'react-yandex-metrika'
import Router from 'next/router'
import '../src/App.css'
import NProgress from 'nprogress' // nprogress module
import LayoutBaseHoc from 'src/pages/layouts/LayoutBaseHoc/LayoutBaseHoc'
import PropTypes from 'prop-types'
import 'dayjs/locale/ru'
import { withEffector } from 'nextjs-effector'

const isProduction = process.env.NEXT_PUBLIC_NODE_ENV === 'production'

function scrollPositionRestorer() {
    const scrollMemories = {}
    // eslint-disable-next-line no-unused-vars
    let isPop = false

    if (process.browser) {
        window.history.scrollRestoration = 'manual'
        window.onpopstate = () => {
            isPop = true
        }
    }

    Router.events.on('routeChangeStart', (url) => {
        // eslint-disable-next-line no-use-before-define
        saveScroll()
        NProgress.start()
        try {
            if (isProduction) {
                ym('hit', url)
            }
        } catch {
            console.log('ym hit is not completed')
        }
    })

    Router.events.on('routeChangeComplete', () => {
        NProgress.done()
        // eslint-disable-next-line no-use-before-define
        restoreScroll()
    })
    Router.events.on('routeChangeError', () => NProgress.done())

    function saveScroll() {
        scrollMemories[Router.asPath] = window.scrollY
    }

    function restoreScroll() {
        const prevScrollY = scrollMemories[Router.asPath]
        if (prevScrollY !== undefined) {
            window.requestAnimationFrame(() => window.scrollTo(0, prevScrollY))
        }
    }
}

scrollPositionRestorer()

/*const SFProDisplayWoff2 = localFont({
    src: [
        {
            path: '../public/assets/fonts/SFProDisplay-Regular.woff2',
            weight: '400',
            style: 'normal'
        },
        {
            path: '../public/assets/fonts/SFProDisplay-Medium.woff2',
            weight: '500',
            style: 'normal'
        },
        {
            path: '../public/assets/fonts/SFProDisplay-Semibold.woff2',
            weight: '600',
            style: 'normal'
        },
        {
            path: '../public/assets/fonts/SFProDisplay-Bold.woff2',
            weight: 'bold',
            style: 'normal'
        },
        {
            path: '../public/assets/fonts/SFProDisplay-Regular.woff',
            weight: '400',
            style: 'normal'
        },
        {
            path: '../public/assets/fonts/SFProDisplay-Medium.woff',
            weight: '500',
            style: 'normal'
        },
        {
            path: '../public/assets/fonts/SFProDisplay-Semibold.woff',
            weight: '600',
            style: 'normal'
        },
        {
            path: '../public/assets/fonts/SFProDisplay-Bold.woff',
            weight: 'bold',
            style: 'normal'
        }
    ],
    variable: '--my-font',
    preload: true
})*/

// eslint-disable-next-line react/prop-types
const App = ({ Component, pageProps }) => {
    return (
        <LayoutBaseHoc mobile={pageProps.mobile}>
            {/* eslint-disable-next-line react/jsx-props-no-spreading */}
            <Component {...pageProps} />
        </LayoutBaseHoc>
    )
}

App.propTypes = {
    pageProps: PropTypes.shape({
        mobile: PropTypes.string
    }).isRequired
}

export default withEffector(App)
